import style from '../../../assets/style/scss/filters.scss'
import FilterTag from './FilterTag'
import { clearFilters } from '../../../actions/filters'

const FilterContainer = props => {
  const { label, children, filterTags, styles = {} } = props
  return (
    <div className={style['filter-container']} role="region" aria-label={label} style={styles}>
      <div className="container">
        <div className={style['filter-components']}>{children}</div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div role="region" aria-label="Active/Applied Filters">
            {filterTags.map((tag, i) => (
              <FilterTag {...tag} key={i} />
            ))}
          </div>
          {filterTags.length > 0 ? (
            <div>
              <button type="button" className="btn btn-secondary" onClick={clearFilters}>
                Clear Filter{filterTags.length > 1 ? 's' : ''}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default FilterContainer
